/* The floating header's script (block ai_gen_block_04fbae6). Was inline in every page; now cached.
 * The block prints the tag that loads this file with two attributes: data-id (the block id, which is part of the class names and of the
 * custom element's name) and data-cfg (the editor texts the script shows: search and cart messages). */
(function (script) {
  var ID = script.getAttribute('data-id');
  var CFG = JSON.parse(script.getAttribute('data-cfg') || '{}');
  (function() {
    class AiHeader extends HTMLElement {
      constructor() {
        super();
        /* Filled from CSS by refreshOffsets(). No default worth guessing here:
           the real values differ per breakpoint and on blog pages. */
        this.restTop = 0;
        this.stuckTop = 0;
        this.dockAt = 0;
        this.dropdownTimeout = null;
        this.searchDebounce = null;
        this.searchOpen = false;
        // IMPROVEMENT 1: Track the last known bubble position for smooth sliding
        this.lastBubbleTarget = null;
      }

      connectedCallback() {
        this.handleScroll = this.handleScroll.bind(this);
        this.handleMouseEnter = this.handleMouseEnter.bind(this);
        this.handleMouseLeave = this.handleMouseLeave.bind(this);
        this.handleMobileMenuItemClick = this.handleMobileMenuItemClick.bind(this);
        this.toggleMobileMenu = this.toggleMobileMenu.bind(this);
        this.handleCartUpdate = this.handleCartUpdate.bind(this);
        this.handleMobileDropdownClick = this.handleMobileDropdownClick.bind(this);
        this.handleMobileDropdownBack = this.handleMobileDropdownBack.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleOverlayClick = this.handleOverlayClick.bind(this);
        this.handleResize = this.handleResize.bind(this);

        /* The Vitamins menu (snippets/pp-hdr-shop-menu.liquid). Desktop: the row under the pointer (or focus) decides what the column on the right shows.
           Phone: a chevron row opens its own window, whose back arrow returns to the menu. Delegated, so it needs nothing from the markup but the data attributes. */
        if (!this.ppShopMenuReady) {
          this.ppShopMenuReady = true;
          const showRow = (e) => {
            const row = e.target.closest ? e.target.closest('[data-pp-sub]') : null;
            const menu = row && row.closest('[data-pp-shopmenu]');
            if (!menu) return;
            const key = row.getAttribute('data-pp-sub');
            menu.querySelectorAll('[data-pp-sub]').forEach(r => r.classList.toggle('is-on', r === row));
            menu.querySelectorAll('[data-pp-sub-panel]').forEach(p => p.classList.toggle('is-on', p.getAttribute('data-pp-sub-panel') === key));
          };
          this.addEventListener('mouseover', showRow);
          this.addEventListener('focusin', showRow);
          this.addEventListener('click', (e) => {
            const open = e.target.closest ? e.target.closest('[data-pp-open]') : null;
            if (!open) return;
            const win = this.querySelector('[data-mobile-dropdown="' + open.getAttribute('data-pp-open') + '"]');
            if (!win) return;
            e.preventDefault();
            const parent = open.closest('.ai-header-mobile-menu-dropdown-' + ID);
            if (parent) parent.classList.remove('active');
            win.classList.add('active');
            win.scrollTop = 0;
          });
        }

        /* Offsets first: handleScroll needs them, and crossing the 990px
           breakpoint changes both, so they are re-read on resize. */
        this.refreshOffsets();
        window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.handleResize);
        this.updateHeaderPosition();

        this.bubble = this.querySelector('.ai-header-nav-bubble-' + ID);
        this.navItems = this.querySelectorAll('.ai-header-nav-' + ID + ' > li');
        
        // --- Hover-glass state handling (desktop) ---
        this.isHeaderHovered = false;

        this.syncHoverGlass = () => {
          const anyDropdownActive = !!this.querySelector('.ai-header-desktop-dropdown-' + ID + '.active');
          const accountDropdownActive = !!this.querySelector('.ai-header-account-dropdown-' + ID + '.active');
          const searchDropdownActive = !!this.querySelector('.ai-header-search-dropdown-' + ID + '.active');
          if (!this.classList.contains('scrolled') && (this.isHeaderHovered || anyDropdownActive || accountDropdownActive || searchDropdownActive)) {
            this.classList.add('hover-glass');
          } else {
            this.classList.remove('hover-glass');
          }
        };

        const headerContainer = this.querySelector('.ai-header-container-' + ID);
        if (headerContainer) {
          headerContainer.addEventListener('mouseenter', () => {
            this.isHeaderHovered = true;
            this.syncHoverGlass();
          });
          headerContainer.addEventListener('mouseleave', () => {
            this.isHeaderHovered = false;
            setTimeout(() => this.syncHoverGlass(), 80);
          });
        }

        this.navItems.forEach((item, index) => {
          item.addEventListener('mouseenter', (e) => {
            this.handleMouseEnter(e);
            this.showDesktopDropdown(index + 1);
            // IMPROVEMENT 5: Update aria-expanded
            const link = item.querySelector('a[aria-expanded]');
            if (link) link.setAttribute('aria-expanded', 'true');
          });
          item.addEventListener('mouseleave', (e) => {
            this.hideDesktopDropdownDelayed(index + 1);
            const link = item.querySelector('a[aria-expanded]');
            if (link) link.setAttribute('aria-expanded', 'false');
          });
        });

        const navWrapper = this.querySelector('.ai-header-nav-wrapper-' + ID);
        if (navWrapper) {
          navWrapper.addEventListener('mouseleave', this.handleMouseLeave);
        }

        // Desktop dropdown hover events
        const desktopDropdowns = this.querySelectorAll('.ai-header-desktop-dropdown-' + ID);
        desktopDropdowns.forEach(dropdown => {
          dropdown.addEventListener('mouseenter', () => {
            clearTimeout(this.dropdownTimeout);
            dropdown.classList.add('active');
            this.syncHoverGlass();
          });
          dropdown.addEventListener('mouseleave', () => {
            dropdown.classList.remove('active');
            setTimeout(() => this.syncHoverGlass(), 80);
          });
        });

        this.mobileBubble = this.querySelector('.ai-header-mobile-menu-bubble-' + ID);
        this.mobileMenuItems = this.querySelectorAll('.ai-header-mobile-menu-nav-' + ID + ' > li');
        
        this.mobileMenuItems.forEach(item => {
          const link = item.querySelector('a');
          if (link) {
            link.addEventListener('click', this.handleMobileMenuItemClick);
          }
        });

        // Mobile dropdown links
        const mobileDropdownLinks = this.querySelectorAll('.ai-header-mobile-menu-nav-' + ID + ' a.has-dropdown');
        mobileDropdownLinks.forEach(link => {
          link.addEventListener('click', this.handleMobileDropdownClick);
        });

        // Mobile dropdown back buttons
        const backButtons = this.querySelectorAll('.ai-header-mobile-menu-dropdown-back-' + ID);
        backButtons.forEach(button => {
          button.addEventListener('click', this.handleMobileDropdownBack);
        });

        const hamburger = this.querySelector('.ai-header-hamburger-' + ID);
        const mobileMenuClose = this.querySelector('.ai-header-mobile-menu-close-' + ID);
        
        if (hamburger) hamburger.addEventListener('click', this.toggleMobileMenu);
        if (mobileMenuClose) mobileMenuClose.addEventListener('click', this.toggleMobileMenu);

        document.addEventListener('cart:updated', this.handleCartUpdate);

        // Mobile account dropdown (logged-in)
        const mobileAccountLink = this.querySelector('.ai-header-mobile-menu-login-' + ID + '[data-dropdown-index]');
        if (mobileAccountLink) {
          mobileAccountLink.addEventListener('click', (e) => {
            e.preventDefault();
            const dropdownIndex = mobileAccountLink.getAttribute('data-dropdown-index');
            const dropdown = this.querySelector('[data-mobile-dropdown="' + dropdownIndex + '"]');

            // Close other open dropdowns
            const openDropdowns = this.querySelectorAll('.ai-header-mobile-menu-dropdown-' + ID + '.active');
            openDropdowns.forEach(d => { if (d !== dropdown) d.classList.remove('active'); });

            // Remove active from nav links
            const allLinks = this.querySelectorAll('.ai-header-mobile-menu-nav-' + ID + ' a.has-dropdown');
            allLinks.forEach(l => { l.classList.remove('active'); l.setAttribute('aria-expanded', 'false'); });

            if (dropdown) {
              dropdown.classList.toggle('active');
              if (dropdown.classList.contains('active')) {
                mobileAccountLink.setAttribute('aria-expanded', 'true');
                // Position mobile bubble on account link
                if (this.mobileBubble) {
                  const rect = mobileAccountLink.getBoundingClientRect();
                  const navRect = this.querySelector('.ai-header-mobile-menu-' + ID).getBoundingClientRect();
                  this.mobileBubble.style.width = rect.width + 'px';
                  this.mobileBubble.style.height = rect.height + 'px';
                  this.mobileBubble.style.left = (rect.left - navRect.left) + 'px';
                  this.mobileBubble.style.top = (rect.top - navRect.top) + 'px';
                  this.mobileBubble.classList.add('active');
                }
              } else {
                mobileAccountLink.setAttribute('aria-expanded', 'false');
                if (this.mobileBubble) this.mobileBubble.classList.remove('active');
              }
            }
          });
        }

        // Account dropdown setup (desktop, logged-in)
        this.setupAccountDropdown();

        // Product search setup
        this.setupSearch();

        // Click outside to close search
        this._handleDocumentClick = (e) => {
          if (!this.searchOpen) return;
          const dropdown = this.querySelector('[data-search-dropdown]');
          const trigger = this.querySelector('[data-search-trigger]');
          const triggerMobile = this.querySelector('[data-search-trigger-mobile]');
          if (dropdown && !dropdown.contains(e.target) && 
              trigger && !trigger.contains(e.target) &&
              (!triggerMobile || !triggerMobile.contains(e.target))) {
            this.closeSearch();
          }
        };
        document.addEventListener('click', this._handleDocumentClick);
        document.addEventListener('touchend', this._handleDocumentClick);

        /* Close the search panel when the pointer leaves it.

           Guarded on purpose. Closing a search box on plain mouse-out is
           hostile: people type with the mouse resting anywhere on the page, and
           losing the panel mid-query is worse than leaving it open. So it only
           closes when the field is empty, which is the case where the panel has
           genuinely been abandoned.

           NOT guarded on focus, although that was the obvious first instinct.
           openSearch() calls input.focus() immediately and again on a timeout,
           so the field is always focused straight after opening and a focus
           guard can never let the close through. Focus here reflects what the
           block did, not what the person did. Whether they typed anything is
           the only honest signal.

           Pointer events, and skipped on touch: there is no hover on a
           touchscreen, and a pointerleave there would fire at the worst moment.

           The delay covers the space between the trigger and the panel, so
           moving diagonally from one to the other does not count as leaving. */
        this._searchLeaveTimer = null;

        this._cancelSearchClose = () => {
          if (this._searchLeaveTimer) {
            clearTimeout(this._searchLeaveTimer);
            this._searchLeaveTimer = null;
          }
        };

        this._handleSearchPointerLeave = (e) => {
          if (!this.searchOpen) return;
          if (e.pointerType === 'touch') return;

          this._cancelSearchClose();
          this._searchLeaveTimer = setTimeout(() => {
            const input = this.querySelector('[data-search-input]');
            const typed = input && input.value.trim() !== '';
            if (typed) return;
            /* Blur first, or focus is left sitting in a panel that is about to
               be hidden, which strands keyboard users on an invisible field. */
            if (input) input.blur();
            this.closeSearch();
          }, 220);
        };

        [this.querySelector('[data-search-dropdown]'), this.querySelector('[data-search-trigger]')]
          .forEach((el) => {
            if (!el) return;
            el.addEventListener('pointerleave', this._handleSearchPointerLeave);
            el.addEventListener('pointerenter', this._cancelSearchClose);
          });

        // IMPROVEMENT 4: Global keyboard listener for Escape
        document.addEventListener('keydown', this.handleKeyDown);

        // IMPROVEMENT 4: Overlay click-outside
        const overlay = this.querySelector('[data-overlay]');
        if (overlay) overlay.addEventListener('click', this.handleOverlayClick);
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
        document.removeEventListener('cart:updated', this.handleCartUpdate);
        document.removeEventListener('keydown', this.handleKeyDown);
        if (this._handleDocumentClick) {
          document.removeEventListener('click', this._handleDocumentClick);
          document.removeEventListener('touchend', this._handleDocumentClick);
        }
        clearTimeout(this.searchDebounce);
      }

      // IMPROVEMENT 4: Escape key dismisses all dropdowns and menus
      handleKeyDown(e) {
        if (e.key === 'Escape') {
          this.dismissAll();
        }
      }

      // IMPROVEMENT 4: Click overlay dismisses all
      handleOverlayClick() {
        this.dismissAll();
      }

      dismissAll() {
        // Close desktop dropdowns
        const activeDropdowns = this.querySelectorAll('.ai-header-desktop-dropdown-' + ID + '.active');
        activeDropdowns.forEach(d => d.classList.remove('active'));

        // Close account dropdown
        this.closeAccountDropdown();

        // Close search
        this.closeSearch();

        // Close mobile menu if open
        const mobileMenu = this.querySelector('.ai-header-mobile-menu-' + ID);
        if (mobileMenu && mobileMenu.classList.contains('active')) {
          this.toggleMobileMenu();
        }

        // Hide overlay
        const overlay = this.querySelector('[data-overlay]');
        if (overlay) overlay.classList.remove('active');

        // Reset ARIA
        this.querySelectorAll('[aria-expanded="true"]').forEach(el => {
          el.setAttribute('aria-expanded', 'false');
        });

        this.syncHoverGlass();
      }

      // Show/hide overlay
      setOverlay(active) {
        const overlay = this.querySelector('[data-overlay]');
        if (overlay) overlay.classList.toggle('active', active);
      }

      /* Read the offsets back out of CSS and derive the one scroll position
         that matters: the point where the travelling header has risen far
         enough to sit at --stuck-top, and should dock. Cached because
         getComputedStyle forces a style resolve. */
      refreshOffsets() {
        const cs = getComputedStyle(this);
        this.restTop = parseFloat(cs.getPropertyValue('--rest-top')) || 0;
        this.stuckTop = parseFloat(cs.getPropertyValue('--stuck-top')) || 0;
        this.dockAt = Math.max(0, this.restTop - this.stuckTop);
      }

      handleResize() {
        this.refreshOffsets();
        this.updateHeaderPosition();
      }

      /* Deliberately synchronous and unthrottled. All this does is toggle a
         class at a single scroll position, which is cheap, and deferring it to
         a rAF would only make the header dock a frame late. */
      handleScroll() {
        this.updateHeaderPosition();
      }

      updateHeaderPosition() {
        /* The only decision left in script: travelling, or docked. Everything
           about where the header actually renders is CSS. */
        this.classList.toggle('scrolled', window.scrollY >= this.dockAt);

        if (this.syncHoverGlass) this.syncHoverGlass();

        // Force header always visible on mobile — counteract any theme-level hide-on-scroll logic
        if (window.innerWidth <= 989) {
          this.style.removeProperty('transform');
          this.style.removeProperty('opacity');
          this.style.removeProperty('visibility');
          this.style.removeProperty('display');
          this.style.removeProperty('pointer-events');
        }
      }

      // IMPROVEMENT 1: Smooth sliding bubble — doesn't jump, it glides
      handleMouseEnter(event) {
        const item = event.currentTarget;
        const link = item.querySelector('a');
        
        if (!link || !this.bubble) return;

        const rect = link.getBoundingClientRect();
        const navRect = this.querySelector('.ai-header-nav-' + ID).getBoundingClientRect();

        const newLeft = rect.left - navRect.left;
        const newWidth = rect.width;
        // +1: the link has 1px more padding above its words than below (see .ai-header-nav li a in
        // pp-header.css, it lines the words up with the logo and Login), so the bubble sits 1px lower
        // to have the words in its middle.
        const newTop = rect.top - navRect.top + 1;
        const newHeight = rect.height;

        // If this is the first hover (no previous target), snap instantly
        if (!this.lastBubbleTarget) {
          this.bubble.style.transition = 'opacity 0.2s ease';
          this.bubble.style.left = newLeft + 'px';
          this.bubble.style.width = newWidth + 'px';
          this.bubble.style.top = newTop + 'px';
          this.bubble.style.height = newHeight + 'px';
          // Restore smooth transition after initial snap
          requestAnimationFrame(() => {
            this.bubble.style.transition = '';
          });
        } else {
          // Slide smoothly to new position
          this.bubble.style.left = newLeft + 'px';
          this.bubble.style.width = newWidth + 'px';
          this.bubble.style.top = newTop + 'px';
          this.bubble.style.height = newHeight + 'px';
        }

        this.bubble.classList.add('active');
        this.lastBubbleTarget = item;
      }

      handleMouseLeave() {
        if (this.bubble) {
          this.bubble.classList.remove('active');
          // Reset so next hover snaps to position
          this.lastBubbleTarget = null;
        }
      }

      // IMPROVEMENT 1: Smooth sliding bubble for mobile menu
      handleMobileMenuItemClick(event) {
        const link = event.currentTarget;
        
        if (link.classList.contains('has-dropdown')) {
          return;
        }
        
        if (!this.mobileBubble) return;

        const rect = link.getBoundingClientRect();
        const navRect = this.querySelector('.ai-header-mobile-menu-' + ID).getBoundingClientRect();

        this.mobileBubble.style.width = rect.width + 'px';
        this.mobileBubble.style.height = rect.height + 'px';
        this.mobileBubble.style.left = (rect.left - navRect.left) + 'px';
        this.mobileBubble.style.top = (rect.top - navRect.top) + 'px';
        this.mobileBubble.classList.add('active');

        setTimeout(() => {
          if (this.mobileBubble) {
            this.mobileBubble.classList.remove('active');
          }
        }, 300);
      }

      // IMPROVEMENT 1: Update mobile bubble position when dropdown link is clicked
      // Closes whichever menu dropdown (Vitamins, Quality...) is showing, so the
      // search panel can take its place under the menu bar.
      closeMobileDropdowns() {
        this.querySelectorAll('.ai-header-mobile-menu-dropdown-' + ID + '.active').forEach(d => d.classList.remove('active'));
        this.querySelectorAll('.ai-header-mobile-menu-nav-' + ID + ' a.has-dropdown').forEach(l => {
          l.classList.remove('active');
          l.setAttribute('aria-expanded', 'false');
        });
        if (this.mobileBubble) this.mobileBubble.classList.remove('active');
      }

      handleMobileDropdownClick(event) {
        event.preventDefault();
        if (this.searchOpen) this.closeSearch();
        const link = event.currentTarget;
        const dropdownIndex = link.getAttribute('data-dropdown-index');
        const dropdown = this.querySelector(`[data-mobile-dropdown="${dropdownIndex}"]`);
        
        // Close any other open dropdowns
        const openDropdowns = this.querySelectorAll('.ai-header-mobile-menu-dropdown-' + ID + '.active');
        openDropdowns.forEach(d => {
          if (d !== dropdown) {
            d.classList.remove('active');
          }
        });
        
        // Remove active class from all menu links
        const allLinks = this.querySelectorAll('.ai-header-mobile-menu-nav-' + ID + ' a.has-dropdown');
        allLinks.forEach(l => {
          l.classList.remove('active');
          l.setAttribute('aria-expanded', 'false');
        });
        
        if (dropdown) {
          dropdown.classList.toggle('active');
          
          if (dropdown.classList.contains('active')) {
            link.classList.add('active');
            link.setAttribute('aria-expanded', 'true');

            // IMPROVEMENT 1: Slide the mobile bubble to the active link
            if (this.mobileBubble) {
              const rect = link.getBoundingClientRect();
              const navRect = this.querySelector('.ai-header-mobile-menu-' + ID).getBoundingClientRect();
              this.mobileBubble.style.width = rect.width + 'px';
              this.mobileBubble.style.height = rect.height + 'px';
              this.mobileBubble.style.left = (rect.left - navRect.left) + 'px';
              this.mobileBubble.style.top = (rect.top - navRect.top) + 'px';
              this.mobileBubble.classList.add('active');
            }
          } else {
            if (this.mobileBubble) {
              this.mobileBubble.classList.remove('active');
            }
          }
        }
      }

      handleMobileDropdownBack(event) {
        const dropdown = event.currentTarget.closest('.ai-header-mobile-menu-dropdown-' + ID);

        /* A row's window (Vitamins menu) goes back to the menu it came from, not to the top menu */
        const backTo = event.currentTarget.getAttribute('data-pp-back-to');
        if (dropdown && backTo) {
          dropdown.classList.remove('active');
          const parent = this.querySelector('[data-mobile-dropdown="' + backTo + '"]');
          if (parent) parent.classList.add('active');
          return;
        }

        if (dropdown) {
          dropdown.classList.remove('active');
          
          const mobileMenu = this.querySelector('.ai-header-mobile-menu-' + ID);
          if (mobileMenu) {
            mobileMenu.classList.add('active');
          }
        }
      }

      toggleMobileMenu() {
        const mobileMenu = this.querySelector('.ai-header-mobile-menu-' + ID);
        const headerContainer = this.querySelector('.ai-header-container-' + ID);
        const firstDropdown = this.querySelector('[data-mobile-dropdown="1"]');
        const menuContent = this.querySelector('.ai-header-mobile-menu-content-' + ID);
        const hamburger = this.querySelector('.ai-header-hamburger-' + ID);
        
        if (mobileMenu && headerContainer) {
          const isOpening = !mobileMenu.classList.contains('active');
          
          // IMPROVEMENT 5: Update hamburger ARIA
          if (hamburger) hamburger.setAttribute('aria-expanded', isOpening ? 'true' : 'false');

          if (isOpening) {
            headerContainer.classList.add('menu-open');
            mobileMenu.classList.add('active');
            
            setTimeout(() => {
              if (firstDropdown) {
                firstDropdown.classList.add('active');
              }
              
              const firstLink = this.querySelector('.ai-header-mobile-menu-nav-' + ID + ' a.has-dropdown[data-dropdown-index="1"]');
              if (firstLink) {
                firstLink.classList.add('active');
                firstLink.setAttribute('aria-expanded', 'true');

                // IMPROVEMENT 1: Position mobile bubble on first link
                if (this.mobileBubble) {
                  const rect = firstLink.getBoundingClientRect();
                  const navRect = this.querySelector('.ai-header-mobile-menu-' + ID).getBoundingClientRect();
                  this.mobileBubble.style.transition = 'opacity 0.2s ease';
                  this.mobileBubble.style.width = rect.width + 'px';
                  this.mobileBubble.style.height = rect.height + 'px';
                  this.mobileBubble.style.left = (rect.left - navRect.left) + 'px';
                  this.mobileBubble.style.top = (rect.top - navRect.top) + 'px';
                  this.mobileBubble.classList.add('active');
                  requestAnimationFrame(() => {
                    this.mobileBubble.style.transition = '';
                  });
                }
              }
            }, 250);
            
          } else {
            // Closing
            if (this.searchOpen) this.closeSearch();
            const openDropdowns = this.querySelectorAll('.ai-header-mobile-menu-dropdown-' + ID + '.active');
            openDropdowns.forEach(dropdown => {
              dropdown.classList.remove('active');
            });
            
            const allLinks = this.querySelectorAll('.ai-header-mobile-menu-nav-' + ID + ' a.has-dropdown');
            allLinks.forEach(link => {
              link.classList.remove('active');
              link.setAttribute('aria-expanded', 'false');
            });

            // Hide mobile bubble
            if (this.mobileBubble) {
              this.mobileBubble.classList.remove('active');
            }
            
            if (menuContent) {
              menuContent.style.opacity = '0';
              menuContent.style.transition = 'opacity 0.15s ease';
            }
            
            setTimeout(() => {
              mobileMenu.classList.remove('active');
              
              setTimeout(() => {
                headerContainer.classList.remove('menu-open');
                
                if (menuContent) {
                  menuContent.style.opacity = '';
                  menuContent.style.transition = '';
                }
              }, 250);
            }, 150);
          }
        }
      }

      handleCartUpdate(event) {
        // Some senders (the cart drawer's add-to-cart translator, third-party cart scripts) dispatch cart:updated WITHOUT the cart in the event.
        // Reading that as 0 items put "Start here" back after the drawer was opened and closed (2026-10-23), so ask the cart for the real count.
        const cart = event && event.detail && event.detail.cart;
        if (cart && typeof cart.item_count === 'number') {
          this.applyCartCount(cart.item_count);
          return;
        }
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((c) => this.applyCartCount(c.item_count))
          .catch(() => {});
      }

      applyCartCount(itemCount) {
        const cartLink = this.querySelector('[data-cart-link]');
        const cartCount = this.querySelector('[data-cart-count]');
        const ctaButton = this.querySelector('[data-cta-button]');
        
        if (cartLink && cartCount) {
          if (itemCount > 0) {
            cartLink.classList.add('has-items');
            if (ctaButton) ctaButton.classList.add('hidden');
            cartCount.textContent = itemCount;
            // IMPROVEMENT 5: Update cart ARIA
            cartLink.setAttribute('aria-label', CFG.cart_items_label.replace('[count]', itemCount));
          } else {
            cartLink.classList.remove('has-items');
            if (ctaButton) ctaButton.classList.remove('hidden');
            cartLink.setAttribute('aria-label', CFG.cart_empty_label);
          }
        }
      }

      showDesktopDropdown(index) {
        clearTimeout(this.dropdownTimeout);

        const allDropdowns = this.querySelectorAll('.ai-header-desktop-dropdown-' + ID);
        allDropdowns.forEach(d => d.classList.remove('active'));

        // Close search if open
        if (this.searchOpen) this.closeSearch();

        if (index <= 3) {
          const dropdown = this.querySelector(`[data-desktop-dropdown="${index}"]`);
          if (dropdown) {
            dropdown.classList.add('active');
          }
        }

        this.syncHoverGlass();
      }

      // IMPROVEMENT 4: Increased timeout to 300ms (matching Seed)
      hideDesktopDropdownDelayed(index) {
        this.dropdownTimeout = setTimeout(() => {
          const dropdown = this.querySelector(`[data-desktop-dropdown="${index}"]`);
          if (dropdown) {
            dropdown.classList.remove('active');
          }
          this.syncHoverGlass();
        }, 300);
      }

      // ========== Account Dropdown (hover-triggered, desktop) ==========
      setupAccountDropdown() {
        const trigger = this.querySelector('[data-account-trigger]');
        const dropdown = this.querySelector('[data-account-dropdown]');
        if (!trigger || !dropdown) return;

        this.accountDropdownTimeout = null;

        // Hover to open
        trigger.addEventListener('mouseenter', () => {
          clearTimeout(this.accountDropdownTimeout);
          this.openAccountDropdown();
        });

        trigger.addEventListener('mouseleave', () => {
          this.accountDropdownTimeout = setTimeout(() => {
            this.closeAccountDropdown();
          }, 300);
        });

        // Click goes to /account
        trigger.addEventListener('click', (e) => {
          // Allow default navigation to /account
        });

        // Keep open while hovering the dropdown itself
        dropdown.addEventListener('mouseenter', () => {
          clearTimeout(this.accountDropdownTimeout);
        });

        dropdown.addEventListener('mouseleave', () => {
          this.accountDropdownTimeout = setTimeout(() => {
            this.closeAccountDropdown();
          }, 300);
        });
      }

      openAccountDropdown() {
        const dropdown = this.querySelector('[data-account-dropdown]');
        const trigger = this.querySelector('[data-account-trigger]');
        if (!dropdown) return;

        // Close nav dropdowns first
        const allNavDropdowns = this.querySelectorAll('.ai-header-desktop-dropdown-' + ID + '.active');
        allNavDropdowns.forEach(d => d.classList.remove('active'));

        // Close search if open
        if (this.searchOpen) this.closeSearch();

        dropdown.classList.add('active');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        this.syncHoverGlass();
      }

      closeAccountDropdown() {
        const dropdown = this.querySelector('[data-account-dropdown]');
        const trigger = this.querySelector('[data-account-trigger]');
        if (!dropdown) return;

        dropdown.classList.remove('active');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        clearTimeout(this.accountDropdownTimeout);
        setTimeout(() => this.syncHoverGlass(), 80);
      }

      // ========== Product Search ==========
      setupSearch() {
        const trigger = this.querySelector('[data-search-trigger]');
        const triggerMobile = this.querySelector('[data-search-trigger-mobile]');
        const dropdown = this.querySelector('[data-search-dropdown]');
        const input = this.querySelector('[data-search-input]');
        const clearBtn = this.querySelector('[data-search-clear]');
        if (!dropdown || !input) return;

        // Toggle on click (desktop)
        if (trigger) {
          trigger.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (this.searchOpen) {
              this.closeSearch();
            } else {
              this.openSearch();
            }
          });
          // Open on hover (desktop only)
          trigger.addEventListener('mouseenter', () => {
            if (!this.searchOpen && window.innerWidth > 989) {
              this.openSearch();
            }
          });
        }

        // Toggle on click (mobile)
        if (triggerMobile) {
          triggerMobile.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (this.searchOpen) {
              this.closeSearch();
            } else {
              this.closeMobileDropdowns();
              this.openSearch();
            }
          });
        }

        // Input handler with debounce
        input.addEventListener('input', () => {
          const query = input.value.trim();
          const clearEl = this.querySelector('[data-search-clear]');
          if (clearEl) {
            clearEl.classList.toggle('visible', query.length > 0);
          }

          clearTimeout(this.searchDebounce);
          if (query.length >= 2) {
            this.searchDebounce = setTimeout(() => {
              this.performSearch(query);
            }, 300);
          } else {
            const results = this.querySelector('[data-search-results]');
            if (results) {
              results.style.display = 'none';
              results.innerHTML = '';
            }
          }
        });

        // Submit on Enter
        input.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            const query = input.value.trim();
            if (query.length > 0) {
              const searchUrl = dropdown.getAttribute('data-search-url') || '/search';
              window.location.href = searchUrl + '?type=product&q=' + encodeURIComponent(query);
            }
          }
        });

        // Clear button
        if (clearBtn) {
          clearBtn.addEventListener('click', () => {
            input.value = '';
            clearBtn.classList.remove('visible');
            const results = this.querySelector('[data-search-results]');
            if (results) {
              results.style.display = 'none';
              results.innerHTML = '';
            }
            input.focus();
          });
        }

        // Keep dropdown open when interacting with it
        dropdown.addEventListener('mouseenter', () => {
          this._searchHover = true;
        });
        dropdown.addEventListener('mouseleave', () => {
          this._searchHover = false;
        });
      }

      openSearch() {
        // Close other dropdowns first
        const allNavDropdowns = this.querySelectorAll('.ai-header-desktop-dropdown-' + ID + '.active');
        allNavDropdowns.forEach(d => d.classList.remove('active'));
        this.closeAccountDropdown();

        const trigger = this.querySelector('[data-search-trigger]');
        const triggerMobile = this.querySelector('[data-search-trigger-mobile]');
        const dropdown = this.querySelector('[data-search-dropdown]');
        const input = this.querySelector('[data-search-input]');
        if (!dropdown) return;

        this.searchOpen = true;
        dropdown.classList.add('active');
        if (trigger) {
          trigger.classList.add('active');
          trigger.setAttribute('aria-expanded', 'true');
        }
        if (triggerMobile) {
          triggerMobile.classList.add('active');
        }

        this.syncHoverGlass();

        // Focus straight away, inside the tap: iOS Safari only raises the
        // keyboard for a focus() made synchronously by the user's gesture, and
        // the old 100ms timeout lost it. The timeout stays as a fallback for
        // when the panel was still hidden at the first call.
        if (input) input.focus({ preventScroll: true });
        setTimeout(() => {
          if (input && document.activeElement !== input) input.focus({ preventScroll: true });
        }, 100);
      }

      closeSearch() {
        const trigger = this.querySelector('[data-search-trigger]');
        const triggerMobile = this.querySelector('[data-search-trigger-mobile]');
        const dropdown = this.querySelector('[data-search-dropdown]');
        const input = this.querySelector('[data-search-input]');
        const clearBtn = this.querySelector('[data-search-clear]');
        const results = this.querySelector('[data-search-results]');
        if (!dropdown) return;

        this.searchOpen = false;
        dropdown.classList.remove('active');
        if (trigger) {
          trigger.classList.remove('active');
          trigger.setAttribute('aria-expanded', 'false');
        }
        if (triggerMobile) {
          triggerMobile.classList.remove('active');
        }

        // Reset field
        if (input) input.value = '';
        if (clearBtn) clearBtn.classList.remove('visible');
        if (results) {
          results.style.display = 'none';
          results.innerHTML = '';
        }

        clearTimeout(this.searchDebounce);
        setTimeout(() => this.syncHoverGlass(), 80);
      }

      performSearch(query) {
        const resultsContainer = this.querySelector('[data-search-results]');
        const dropdown = this.querySelector('[data-search-dropdown]');
        if (!resultsContainer || !dropdown) return;

        // Get routes from Liquid data attributes
        const predictiveUrl = dropdown.getAttribute('data-predictive-url') || '/search/suggest';
        const searchUrl = dropdown.getAttribute('data-search-url') || '/search';

        // Show loading
        resultsContainer.style.display = 'block';
        resultsContainer.innerHTML = '<div class="ai-header-search-loading-' + ID + '"><div class="ai-header-search-spinner-' + ID + '"></div></div>';

        // Try predictive search JSON API first
        fetch(predictiveUrl + '.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6', {
          headers: { 'Accept': 'application/json' }
        })
          .then(res => {
            if (!res.ok) throw new Error('suggest-fail');
            return res.json();
          })
          .then(data => {
            const products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (products.length > 0) {
              this.renderSearchResults(products, query, resultsContainer, 'suggest');
            } else {
              this.searchViaPage(query, resultsContainer, searchUrl);
            }
          })
          .catch(() => {
            this.searchViaPage(query, resultsContainer, searchUrl);
          });
      }

      // Guaranteed fallback: fetch the actual /search page and parse product HTML
      searchViaPage(query, container, searchUrl) {
        const url = (searchUrl || '/search') + '?q=' + encodeURIComponent(query) + '&type=product&options%5Bprefix%5D=last';
        fetch(url, {
          headers: { 'Accept': 'text/html' }
        })
          .then(res => {
            if (!res.ok) throw new Error('search-page-fail');
            return res.text();
          })
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const products = [];

            // Strategy 1: Look for product links with structured data
            const productCards = doc.querySelectorAll(
              '[data-grid-item], .product-item, .grid-item, .search-results-item, [data-product-card]'
            );

            productCards.forEach(card => {
              const link = card.querySelector('a[href*="/products/"]');
              if (!link) return;

              const url = link.getAttribute('href') || '';
              // Try multiple selectors for title
              const titleEl = card.querySelector(
                '.product-item__title, .item-link, .product-title, h3, h2, .title'
              );
              let title = '';
              if (titleEl) {
                title = titleEl.textContent.trim();
              } else {
                // Use the link text itself
                title = link.textContent.trim().split('\n')[0].trim();
              }

              const img = card.querySelector('img');
              const image = img ? (img.getAttribute('src') || img.getAttribute('data-src') || '') : '';

              if (title && url && !products.find(p => p.url === url)) {
                products.push({ title: title, url: url, image: image });
              }
            });

            // Strategy 2: If no structured cards found, just grab all /products/ links
            if (products.length === 0) {
              const allProductLinks = doc.querySelectorAll('a[href*="/products/"]');
              allProductLinks.forEach(link => {
                const url = link.getAttribute('href') || '';
                const title = link.getAttribute('aria-label') || link.textContent.trim().split('\n')[0].trim();
                const img = link.querySelector('img');
                const image = img ? (img.getAttribute('src') || '') : '';

                if (title && title.length > 1 && url && !products.find(p => p.url === url)) {
                  products.push({ title: title, url: url, image: image });
                }
              });
            }

            // Limit to 6 results
            const limited = products.slice(0, 6);

            if (limited.length > 0) {
              this.renderSearchResults(limited, query, container, 'page');
            } else {
              container.innerHTML = '<div class="ai-header-search-empty-' + ID + '">' + CFG.search_no_results + ' \u201c' + query.replace(/</g, '&lt;').replace(/>/g, '&gt;') + '\u201d</div>';
            }
          })
          .catch(() => {
            container.innerHTML = '<div class="ai-header-search-empty-' + ID + '">' + CFG.search_unavailable + '</div>';
          });
      }

      renderSearchResults(products, query, container, source) {
        if (!products.length) {
          container.innerHTML = '<div class="ai-header-search-empty-' + ID + '">' + CFG.search_no_results + ' \u201c' + query.replace(/</g, '&lt;').replace(/>/g, '&gt;') + '\u201d</div>';
          return;
        }

        let html = '<div class="ai-header-search-results-heading-' + ID + '">' + CFG.search_results_heading + '</div>';

        products.forEach(product => {
          // Build image HTML
          let imgHtml = '';
          const imgSrc = product.image || (product.featured_image && product.featured_image.url) || '';
          if (imgSrc) {
            imgHtml = '<img src="' + imgSrc + '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" width="58" height="58" loading="lazy">';
          } else {
            imgHtml = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="rgba(255,255,255,0.3)" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="8.5" cy="8.5" r="1.5" /><path d="M21 15l-5-5L5 21" /></svg>';
          }

          // Build price HTML (only from suggest API — page parsing doesn't give us clean prices)
          let price = '';
          if (source === 'suggest') {
            const rawPrice = product.price_min || product.price;
            if (rawPrice) {
              const num = parseFloat(rawPrice);
              if (!isNaN(num) && num > 0) {
                price = num.toFixed(2).replace('.', ',') + ' kr';
              }
            }
          }

          const productType = product.type || '';
          const productUrl = product.url || ('/products/' + (product.handle || ''));

          html += '<a href="' + productUrl + '" class="ai-header-search-result-item-' + ID + '">'
            + '<div class="ai-header-search-result-img-' + ID + '">' + imgHtml + '</div>'
            + '<div class="ai-header-search-result-info-' + ID + '">'
            + '<div class="ai-header-search-result-title-' + ID + '">' + (product.title || '') + '</div>'
            + (productType ? '<div class="ai-header-search-result-type-' + ID + '">' + productType + '</div>' : '')
            + '</div>'
            + (price ? '<div class="ai-header-search-result-price-' + ID + '">' + price + '</div>' : '')
            + '</a>';
        });

        // View all link
        const viewAllUrl = (this.querySelector('[data-search-dropdown]').getAttribute('data-search-url') || '/search');
        html += '<div class="ai-header-search-view-all-' + ID + '">'
          + '<a href="' + viewAllUrl + '?type=product&q=' + encodeURIComponent(query) + '">'
          + CFG.search_view_all
          + '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7" /></svg>'
          + '</a></div>';

        container.innerHTML = html;
      }

    }

    customElements.define('ai-header-' + ID, AiHeader);

    document.addEventListener('DOMContentLoaded', function() {
      let originalFetch = window.fetch;
      window.fetch = function() {
        return originalFetch.apply(this, arguments).then(function(response) {
          if (response.url.includes('/cart/')) {
            fetch('/cart.js')
              .then(res => res.json())
              .then(cart => {
                document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
              });
          }
          return response;
        });
      };
    });
  })();
})(document.currentScript);
